// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__jfrjO","input":"styles_input__3gEp8","icon":"styles_icon__UwyEF"};